/* eslint-disable react/prop-types */
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import fixTableCellWidth from "../../functions/fixTableCellWidth";
import SoftBadge from "../../components/SoftBadge";
import { deleteBusinessSuggestion } from "../../api/routes";
import { toast } from "react-toastify";
import { useState } from "react";
import Loading from "../../components/Loading";

function createData(id, name, address, lat, long, image, createdAt, operation, mapLink, user) {
    return {
        id,
        name,
        address,
        lat,
        long,
        image,
        createdAt,
        operation,
        mapLink,
        user
    };
}

function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("160px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.address}
                    style={fixTableCellWidth("200px")}>{row.address}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("170px")}>{row.user?.first_name} {row.user?.last_name}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("120px")}>
                    {row.image && <img src={row.image} alt={row.name} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, cursor: "pointer" }} onClick={() => window.open(row.image, "_blank")} />}
                </TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>
                    <SoftBadge variant="contained"
                        badgeContent="نقشه"
                        color="info" size="xs"
                        onClick={() => window.open(row.mapLink, "_blank")}
                        style={{ cursor: "pointer" }} />
                </TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("160px")}>{row.createdAt}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("120px")}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function BusinessSuggestionTable({ data }) {
    const [loading, setLoading] = useState(false);
    const handleDelete = (id) => {
        let answer = window.confirm("آیا از حذف اطمینان دارید؟");
        if (answer) {
            setLoading(true);
            deleteBusinessSuggestion(id, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    toast.success("با موفقیت حذف شد");
                }
            })
        }
    }
    const rows = data.map(item => createData(item.id, item.name, item.address, item.lat, item.long,
        item.image, item?.created_at,
        <section style={{ display: "flex", cursor: 'pointer' }}>
            <SoftBadge variant="contained"
                badgeContent="حذف"
                onClick={() => handleDelete(item.id)}
                color="error" size="xs" />
        </section>,
        `https://neshan.org/maps/routing/car/destination/${item.lat},${item.long}`,
        item.user
    ))

    return (
        <>
            <TableContainer component={Paper}>
                <Loading loading={loading} />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("160px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("200px")}>آدرس</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>کاربر</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>تصویر</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("100px")}>موقعیت</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("160px")}>تاریخ ایجاد</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>عملیات ها</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {rows.map((row) => (
                            <Row key={row.id} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
